const PUBLIC_API = "http://localhost:3000";
export {
  PUBLIC_API as P
};
